// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"6":"a0d01c1350ef7d091b77","926":"edd15ecdd3e92448201b"}[chunkId] + ".bundle.css";
};